'use strict';

exports.__esModule = true;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _config = require('./../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path) {
  var adjustedPath = path[0] !== '/' ? '/' + path : path;
  var pathParams = adjustedPath.split('/');
  var url = '';
  if (__SERVER__) {
    return 'http://' + _config2.default.apiHost + ':' + _config2.default.apiPort + adjustedPath;
  }
  if (pathParams[1] === 'auth') {
    url = 'https://' + window.env.devHost + adjustedPath;
  } else {
    url = 'https://' + window.env.devHost + '/api' + adjustedPath;
  }
  return url;
}

var ApiClient = function () {
  function ApiClient(req) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ApiClient);

    methods.forEach(function (method) {
      _this[method] = function (path) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            params = _ref.params,
            data = _ref.data;

        return new _promise2.default(function (resolve, reject) {
          _this.sendRequest(req, params, data, reject, method, resolve, path, 1);
        });
      };
    });
  }

  ApiClient.prototype.retry = function retry(req, params, data, reject, method, resolve, path, retryCount, error) {
    if (retryCount < 3) {
      this.sendRequest(req, params, data, reject, method, resolve, path, retryCount + 1);
    } else {
      reject(error);
    }
  };

  ApiClient.prototype.sendRequest = function sendRequest(req, params, data, reject, method, resolve, path, retryCount) {
    var _this2 = this;

    var request = _superagent2.default[method](formatUrl(path));
    var headers = headers ? headers : { 'Accept': '*/*' };
    if (headers) {
      request.set(headers);
    }
    request.withCredentials();
    if (params) {
      params.random = Math.random();
      request.query(params);
    }
    if (__SERVER__ && req.get('cookie')) {
      request.set('cookie', req.get('cookie'));
    }
    if (data) {
      request.send(data);
    }
    request.end(function (err) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          body = _ref2.body;

      return err ? _this2.retry(req, params, data, reject, method, resolve, path, retryCount, body || err) : resolve(body);
    });
  };

  return ApiClient;
}();

exports.default = ApiClient;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/ApiClient.js
// module id = 1492
// module chunks = 0